$( document ).ready(function() {
    if ($(".toc-list ").length){
        $(".toc-container").css({"display": "block"});
    } else {
        $(".toc-container").css({"display": "none"});
    }
});
if ($('.stars').length ) {
    let starID = $('.stars').attr("id");
    $(".starsItem").click(function () {
        let activeStar = $(this).attr("data-target");
        localStorage.setItem('starWidget-' + starID, activeStar);
        $('.stars').addClass(activeStar).addClass("disabled");
    });

    if (localStorage['starWidget-' + starID]) {
        let activeStar1 = localStorage.getItem('starWidget-' + starID);
        $('.stars').addClass("disabled").addClass(activeStar1);
    }
}

$( document ).ready(function()  {
    if ($(".scrollPoint ").length) {
        const readingProgress = (contentArea, progressBar) => {
            const content = document.querySelector(contentArea);
            const progress = document.querySelector(progressBar);
            const progressPoint = document.getElementById('progressPoint');

            const frameListening = () => {
                const contentBox = content.getBoundingClientRect();
                const midPoint = window.innerHeight / 2;

                if (contentBox.top > midPoint) {
                    progress.value = 0;
                }

                if (contentBox.top < midPoint) {
                    progress.value = progress.max;
                }

                if (contentBox.top <= midPoint && contentBox.bottom >= midPoint) {
                    progress.value = (progress.max * Math.abs(contentBox.top - midPoint)) / contentBox.height ;
                    progressPoint.style.width = progress.value + '%';
                }

                window.requestAnimationFrame(frameListening);
            };

            window.requestAnimationFrame(frameListening);
        };
        readingProgress(".scrollPoint", ".reading-progress");
    }
});

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(initIdGa, 3000);
});

window.getCookie = function(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
}

function initIdGa() {
    const idFromGa = getCookie('_ga');
    let idFromGaResult = idFromGa.substr(6);
    if (($('#acForm').length > 0) || ($('#acForm2').length > 0)) {
        document.querySelectorAll('[data-name="clientidfromga"]').forEach(function (element, index) {
            element.setAttribute('value', idFromGaResult);
        });
    }
}

$(document).ready(() => {
    let formCurrentUrl = (window.location.hostname + window.location.pathname).toString();
    if (($('#acForm').length > 0) || ($('#acForm2').length > 0)) {
        document.querySelectorAll('[data-name="sended_from_page"]').forEach(function (element, index) {
            element.setAttribute('value', formCurrentUrl);
        });
    }
});

